import { createAction, props } from '@ngrx/store';

import { common } from '@qwyk/models';
import { PageRequest } from '@qwyk/ui-standalone';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { Shipment } from '@qwyk/shared-stores/shipments';

import { ShipmentPackage } from './shipment-packages.models';

export const loadShipmentPackages = createAction(
    '[Portals/Shipments/Packages] Load ShipmentPackages',
    props<{ shipmentId: string; query: PageRequest }>()
);

export const loadShipmentPackagesSuccess = createAction(
    '[Portals/Shipments/Packages] Load ShipmentPackages Success',
    props<{ shipmentPackages: ShipmentPackage[]; pagination: common.PaginationMeta }>()
);

export const loadShipmentPackagesFailure = createAction(
    '[Portals/Shipments/Packages] Load ShipmentPackages Failure',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props<{ error: any }>()
);

export const updateShipmentPackage = createAction(
    '[Portals/Shipments/Packages] Update ShipmentPackage',
    props<{ shipment: Shipment; shipmentPackage: ShipmentPackage }>()
);

export const updateShipmentPackageSuccess = createAction(
    '[Portals/Shipments/Packages] Update ShipmentPackage Success',
    props<{ shipmentPackage: ShipmentPackage }>()
);

export const updateShipmentPackageFailure = createAction(
    '[Portals/Shipments/Packages] Update ShipmentPackage Failure',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props<{ error: any }>()
);

export const selectShipmentPackage = createAction(
    '[Portals/Shipments/Packages] Select ShipmentPackage',
    props<{ shipmentPackage: ShipmentPackage }>()
);
export const unselectShipmentPackage = createAction(
    '[Portals/Shipments/Packages] Unselect ShipmentPackage'
);

export const reset = createAction('[Portals/Shipments/Packages] Reset');
